import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class DkDateAdapter extends NativeDateAdapter {
  parse(value: string): Date | null {
    if (typeof value === 'string' && value == '') {
      return null;
    }

    if (typeof value != 'string') {
      this.invalid();
    }

    let today = new Date();

    if (value == 'dd' || value == 'DD') {
      return today;
    }

    //matches dd+x or dd-x
    if (value.match('[dD][dD][+-][0-9]+')) {
      let seperator = value.indexOf('+') > 0 ? '+' : '-';
      const str = value.split(seperator);
      let numberOfDays = str[str.length - 1];

      let calculatedDate = new Date();
      if (seperator == '+') {
        calculatedDate.setDate(today.getDate() + Number.parseInt(numberOfDays));
      } else {
        calculatedDate.setDate(today.getDate() - Number.parseInt(numberOfDays));
      }
      return calculatedDate;
    }

    //Regular dates
    let seperator = '.';
    if (value.indexOf(seperator) < 0) {
      seperator = value.indexOf('/') > 0 ? '/' : '-';
    }
    //No seperator
    if (
      value.indexOf(seperator) < 0 &&
      (value.length == 6 || value.length == 8)
    ) {
      const year = Number(value.substring(4));
      const month = Number(value.substring(2, 4)) - 1;
      const date = Number(value.substring(0, 2));

      if (month >= 0 && month < 12 && date > 0 && date <= 31) {
        return new Date(year < 100 ? 2000 + year : year, month, date);
      }
    }
    //Legal seberator
    if (value.indexOf(seperator) > -1) {
      const str = value.split(seperator);

      if (str.length < 3) {
        return this.invalid();
      }

      const year = Number(str[2]);
      const month = Number(str[1]) - 1;
      const date = Number(str[0]);

      if (month >= 0 && month < 12 && date > 0 && date <= 31) {
        return new Date(year < 100 ? 2000 + year : year, month, date);
      }
    }

    return this.invalid();
  }

  format(date: Date, displayFormat: Object): string {
    date = new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
      )
    );
    displayFormat = Object.assign({}, displayFormat, { timeZone: 'utc' });

    const dtf = new Intl.DateTimeFormat(this.locale, displayFormat);
    return dtf.format(date).replace(/[\u200e\u200f]/g, '');
  }
}
